export default __webpack_public_path__ + "static/media/person_3@2x.13313065.png";